import service from '@/utils/request';

// 跳转登录接口
export function jumpLogin (data) {
  return service({
    url: '/v1/auth/jumpLogin',
    method: 'get',
    params: data
  })
}

// 获取首页展示工具
export function menuList (data) {
  return service({
    url: '/v1/module3/homeList',
    method: 'get',
    params: data
  })
}

// 获取首页展示工具
export function menuNewList (data) {
  return service({
    url: '/v1/module3/list',
    method: 'get',
    params: data
  })
}

// 获取新chatId
export function getNewChatId (data) {
  return service({
    url: '/v1/chat/getNewChatId',
    method: 'get',
    params: data
  })
}

// 根据uuid获取对话记录
export function dialogues (data) {
  return service({
    url: '/v1/chat/dialogues',
    method: 'get',
    params: data
  })
}
// 根据uuid获取ppt对话记录
export function pptRecordDialogues (data) {
  return service({
    url: '/v1/chat/pptRecord/dialogues',
    method: 'get',
    params: data
  })
}

// 将AI返回的对话转换为word文档
export function chatToWord (data) {
  return service({
    url: '/v1/word/chatToWord',
    method: 'get',
    params: data
  })
}

// 获取对话参数配置
export function chatOptionsByChatType (data) {
  return service({
    url: '/v1/chat/chatOptionsByChatType',
    method: 'get',
    params: data
  })
}

// 获取对话参数配置2
export function chatOptions2 (data) {
  return service({
    url: '/v1/chat/chatOptions2',
    method: 'get',
    params: data
  })
}

// 登出
export function logout (data) {
  return service({
    url: '/v1/auth/logout',
    method: 'get',
    params: data
  })
}

// 获取用户document列表
export function getDictByParentId (data) {
  return service({
    url: '/v1/dict/getDictByParentId',
    method: 'get',
    params: data
  })
}

export function getImgSwipe (data) {
  return service({
    url: '/v1/auth/getImgSwipe',
    method: 'get',
    params: data
  })
}

export function rstImgSwipe (data) {
  return service({
    url: '/v1/auth/rstImgSwipe',
    method: 'post',
    data
  })
}

export function userLogin (data) {
  return service({
    url: '/v1/auth/aILogin',
    method: 'post',
    data
  })
}


// AI助手发送手机验证码
export function sendAIPhone (data) {
  return service({
    url: '/v1/auth/sendAIPhone',
    method: 'post',
    data: data
  })
}


// AI助手用户注册-使用验证码
export function registerAIAccount (data) {
  return service({
    url: '/v1/auth/registerAIAccount',
    method: 'post',
    data: data
  })
}

// AI助手用户重置密码-使用验证码
export function resetAIPassword (data) {
  return service({
    url: '/v1/auth/resetAIPassword',
    method: 'post',
    data: data
  })
}

// 上传文件，返回地址(txt word pdf)
export function uploadFileUniversal (data) {
  return service({
    url: '/v1/document/uploadFileUniversal',
    method: 'post',
    data,
    headers:{
      'ContentType': 'application/json;charset=UTF-8',
    }
  })
}

// 上传文件，返回地址
export function uploadFile (data) {
  return service({
    url: '/v1/document/uploadFile',
    method: 'post',
    data,
    headers:{
      'ContentType': 'application/json;charset=UTF-8',
    }
  })
}

// 是否能够发起访问，传参和正式发起访问一样
export function canChat (data) {
  return service({
    url: '/v1/chat/canChat',
    method: 'post',
    data
  })
}

// 获取专业层级 一级专业字段必须穿
export function getMajors (data) {
  return service({
    url: '/v1/undergraduateMajors/getMajors',
    method: 'get',
    params: data
  })
}


// 获取游戏或动画返回
export function getGameHtml (data) {
  return service({
    url: '/v1/game/getGameHtml',
    method: 'post',
    data: data
  })
}



// 修改用户详情
export function updateUserDetail (data) {
  return service({
    url: '/v1/userDetail/update',
    method: 'post',
    data: data
  })
}


// 根据用户ID查询用户详情
export function getByUserId (data) {
  return service({
    url: '/v1/userDetail/getByUserId',
    method: 'get',
    params: data
  })
}



// 上传用户头像
export function uploadAvatar (data) {
  return service({
    url: '/v1/userDetail/uploadAvatar',
    method: 'post',
    data: data
  })
}


// 获取他人主页收藏的/发布的
export function getOthersResource (data) {
  return service({
    url: '/v1/design/getOthersResource',
    method: 'get',
    params: data
  })
}



// 查看这个人是已关注还是未关注 返回true已关注 false未关注
export function userFollow (data) {
  return service({
    url: '/v1/userFollow/check',
    method: 'get',
    params: data
  })
}


// 关注/取消关注
export function changeFollowStatus (data) {
  return service({
    url: '/v1/userFollow/changeFollowStatus',
    method: 'get',
    params: data
  })
}


// 我的关注列表
export function myFollowedList (data) {
  return service({
    url: '/v1/userFollow/myFollowedList',
    method: 'post',
    data: data
  })
}


// 我的粉丝列表
export function myFollowerList (data) {
  return service({
    url: '/v1/userFollow/myFollowerList',
    method: 'post',
    data: data
  })
}


// 移除粉丝
export function deleteFollower (data) {
  return service({
    url: '/v1/userFollow/deleteFollower',
    method: 'get',
    params: data
  })
}


// 刷新主页最后访问时间
export function refreshLastViewTime (data) {
  return service({
    url: '/v1/userFollow/refreshLastViewTime',
    method: 'get',
    params: data
  })
}


// 获取审核失败原因 空串表示无
export function getAuditReason (data) {
  return service({
    url: '/v1/design/getAuditReason',
    method: 'get',
    params: data
  })
}



// 获取tree结构的列表
export function getcityDict (data) {
  return service({
    url: '/v1/cityDict/list/tree',
    method: 'get',
    params: data
  })
}



// 统计评论数量
export function getCommentCount (data) {
  return service({
    url: '/v1/comment/count',
    method: 'post',
    data: data
  })
}


// 条件查询评论列表（分页）
export function getCommentlist (data) {
  return service({
    url: '/v1/comment/list',
    method: 'post',
    data: data
  })
}


// 新增评论
export function saveComment (data) {
  return service({
    url: '/v1/comment/save',
    method: 'post',
    data: data
  })
}



// 删除评论
export function deleteComment (data) {
  return service({
    url: '/v1/comment/delete',
    method: 'DELETE',
    params: data
  })
}

//结束对话
export function closeChat (data) {
  return service({
    url: '/v1/chat/closeChat',
    method: 'get',
    params: data
  })
}